import { SecureField } from "@/components/Checkout/Payment/secureField/secureField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { SubmitPaymentButton } from "../../submitPaymentButton/submitPaymentButton.container";

const CreditCardPayment = () => {
    const { t } = useGranite();

    return (
        <>
            <Row className={"pt-3"}>
                <Col>
                    <SecureField
                        name="cardHolder"
                        label={t("checkout.psp.paymentMethods.card.holder")}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <SecureField
                        name="cardNumber"
                        label={t("checkout.psp.paymentMethods.card.number")}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <SecureField
                        name="expiryDate"
                        label={t(
                            "checkout.psp.paymentMethods.card.expiry.date"
                        )}
                    />
                </Col>
                <Col md={6}>
                    <SecureField
                        name="verificationCode"
                        label={t(
                            "checkout.psp.paymentMethods.card.security.number"
                        )}
                        tooltip={{
                            title: t(
                                "checkout.psp.paymentMethods.creditCard.cvc.tooltip.title"
                            ),
                            body: t(
                                "checkout.psp.paymentMethods.creditCard.cvc.tooltip.body"
                            )
                        }}
                    />
                </Col>
            </Row>
            <Row className={"pb-2"}>
                <Col>
                    <SubmitPaymentButton />
                </Col>
            </Row>
        </>
    );
};

export { CreditCardPayment };
